<app-online-header
  step="{{ pUiService.currentStep }}"
  title="{{
    pUiService.productView.ProductItem == null
      ? 'דף לא קיים'
      : pUiService.productView.ProductItem.Name
  }}"
></app-online-header>

<div
  class="container-fluid online-content-cube-wrapper"
  *ngIf="pUiService.productView.ProductItem != null && pUiService.chosenOption && clientTransactionViewForm"
  [formGroup]="clientTransactionViewForm"
>
  <app-product-details-step1 
  *ngIf="pUiService.activeStages[0]"
  [clientTransactionViewForm]="clientTransactionViewForm"
  ></app-product-details-step1>
<app-product-details-step2 
*ngIf="pUiService.activeStages[1]"
[clientTransactionViewForm]="clientTransactionViewForm"
></app-product-details-step2>
<div
*ngIf="pUiService.activeStages[0]"
class="product-detail-row" 
[ngClass]="{ 'full-opacity': pUiService.isFullOpacity }"
>
<div class="row">
  <div class="col-md-1 col-sm-0"></div>
  <div class="col-md-10">
    <div class="row">
      <div class="col-md-12">
          <app-product-description
          [description]="pUiService.productView.ProductItem.Description"
          [finalPrice]="pUiService.finalPrice.value"
          ></app-product-description>

          <app-product-price-list></app-product-price-list>

          <app-comments
             
            ></app-comments>
      </div>
    </div>
  </div>
</div>
</div>
</div>


<div class="container-fluid" *ngIf="pUiService.productView.ProductItem == null">
  <div class="row">
    <div class="col-md-1 col-sm-0"></div>
    <div class="col-md-10 online-content-cube-wrapper">דף לא קיים במערכת</div>
  </div>
</div>



<div id="back-to-stage-1" (click)="backToStageOne()"></div>
<div id="go-to-stage-2" (click)="continueOrder(1)"></div>
<app-picture-slider 
[displayCurrentPic]="pUiService.displayCurrentPic"
[currentPic]="pUiService.currentPic"
[productPictureItems]="pUiService.productView.ProductPictureItems"
></app-picture-slider>
<app-comment-form
></app-comment-form>